import { createSelector } from '@ngrx/store';
import { AppStateInterface } from 'src/app/store/types';

export const selectNotificationsData = (state: AppStateInterface) =>
  state.notificationData;

export const isLaodingNotificationsDataSelector = createSelector(selectNotificationsData, (state) => state.isLoading)
export const successNotificationsDataSelector = createSelector(selectNotificationsData, (state) => state.notifications)
export const errorNotificationsDataSelector = createSelector(selectNotificationsData, (state) => state.error)

export const isLaodingBookmarkedNotificationsDataSelector = createSelector(selectNotificationsData, (state) => state.isLoading)
export const successBookmarkedNotificationsDataSelector = createSelector(selectNotificationsData, (state) => state.markedNotifications)
export const errorBookmarkedNotificationsDataSelector = createSelector(selectNotificationsData, (state) => state.error)
